<template>
    <div class="container">
        <h1>Для отрамання файлів з google drive потрібно отримати acess_token</h1>

        <div class="flex">
            <p>1. Отримати код</p> <a :href="codeUrl">Отримати код</a>
        </div>
        <br>
        <input style="width: 100%;" v-model="codeUrl" >
        <br>
        <br>
        <p>Код: </p>
        <input style="width: 100%;" :value="code" >
        <br>
        <br>
        <p>2. Отримати acess_token</p>
        <div class="flex">
            <input style="width: 100%;" v-if="tkn" :value="tkn" >
            <input v-else style="width: 100%;" :value="token" >
            <button @click="getAcessToken">Отримати acess_token</button>
        </div>
    </div>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";
import axios from "axios";
import Button from '../Jetstream/Button.vue';
export default {
  components: { Button },
    props: {
        code: {
            type: String,
            default: null
        },
        tkn: {
            type: String,
            default: null
        },
    },
    layout: AppLayout,
    components: {
        AppLayout,
    },
    data() {
        return {
            codeUrl: 'https://accounts.google.com/o/oauth2/auth?scope=https://www.googleapis.com/auth/drive&response_type=code&access_type=offline&redirect_uri=https://vector.sinepolsky.website/google-api-auth&client_id=47000664685-n5ru2lb8iamjcfj8iu8d4eatup3l7uts.apps.googleusercontent.com',
            token: null,
        }
    },
    methods: {
        getAcessToken()
        {
            axios.post(this.route('api.vector.get-google-access-token'), {code: this.code})
                .then((result) => {
                    this.token = result.data.tokent;
                }).catch((error) => {
                    alert('Помилка читання');
                    window.scroll(0, 0);
                })
        }
    }
}
</script>

<style scoped>
.container {
    padding: 40px;
}
.flex {
    display: flex;
    align-items: center;
    gap: 20px;
}
.flex p {
    margin: 0px;
}
</style>
